module.exports = __webpack_public_path__ + "static/media/model-xtrail-t31.f690ca3a.webp";